import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import { getImageProps } from 'app/utilities/ImageProps';
import EquipmentMine from '../EquipmentMine/EquipmentMine';

import arrowPurple from '../../icons/arrow-purple.svg';
import authenticationProvider from '../../../../../utilities/authentication/authenticationProvider';
import { getSubscribersByProductAsync } from '../../EquipmentMainAsyncThunk';
import { switchExtraction } from 'app/utilities/analytics/tracking';
import { prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import { reportDWH } from '../../EquipmentMainSlice';
import { setRedirectUrl } from '../../../../../utilities/authentication/authenticationSlice';
import EpiContext from '@episerver/spa-core/Spa';

function Header({isLoading,setIsLoading, type, setRedirectUrl ,epiData, loginData, isAuthenticateFinish, moreDetails, openInstallationGuide, getSubscribersByProductAsync, listEquipmentsMine }) {
    if(!isAuthenticateFinish){ return null; }

    // product is displayed
    let nameWorld;
    let productName;
    let hebrewTranslation;

    switch (epiData.productType) {
        case 1:
            nameWorld = 'internet';
            productName= 'נתב'
            hebrewTranslation= 'אינטרנט'
            break;
        case 3:
            nameWorld = 'internet';
            productName= 'מגדיל טווח'
            hebrewTranslation= 'אינטרנט'
            break;
        case 2:
            nameWorld = 'tv';
            productName= 'ממיר'
            break;
        default:
            nameWorld = 'No-Equipment';
    };
    
    useEffect(() => {
        if(loginData.isFullAuthenticated || loginData.isOtpAuthenticated || loginData.isOtpExtendedAuthenticated || loginData.isSilentOtpAuthenticated) {
            const fetchResult = async () => {
                if(nameWorld !== 'No-Equipment'){
                    setIsLoading(true);
                    const result = await getSubscribersByProductAsync(nameWorld); 
                    setIsLoading(false);
                    if(props.mesError !== 0 ){
                        reportDWH({ actionType: 'GeneralEquipment Page', status: 'Error', messageText: 'General Error' });
                    };
                };
            };            
            fetchResult();
        };
    }, [loginData.isAuthenticateFinish]);


    const clickLogin = async () => {
        setRedirectUrl(window.location.pathname);
        prepareUrl(Config.newLoginUrl, EpiContext);
    };

    return (
        <div className="layout">
          <h2 style={{ paddingBottom: nameWorld === 'No-Equipment' ? '252px' : '39px' }}>{epiData?.mainTitle}</h2>
            {(nameWorld !== 'No-Equipment' &&
              (loginData?.isFullAuthenticated ||
               loginData?.isOtpAuthenticated ||
               loginData?.isOtpExtendedAuthenticated ||
               loginData?.isSilentOtpAuthenticated)) ? (
                <EquipmentMine
                    listEquipmentsMine={listEquipmentsMine}
                    moreDetails={moreDetails}
                    openInstallationGuide={openInstallationGuide}
                    productName={productName}
                    hebrewTranslation={hebrewTranslation}
                    isLoading={isLoading}
                    type={type}
                />
            ) : (
                nameWorld !== 'No-Equipment' && (
                    <button className="header-button" onClick={() => clickLogin()}>
                        <div>{epiData?.titleButton}</div>
                        <Image src={arrowPurple} alt="icon" />
                    </button>
                )
            )}
        </div>
    );
}


const mapStateToProps = (state) => ({
    epiData: state.equipmentListPage.epiData,
    loginData: state.authentication.loginData,
    isAuthenticateFinish: state.authentication.isAuthenticateFinish,
    mesError: state.equipmentListPage.mesError
});

const mapDispatchToProps = {
    getSubscribersByProductAsync,
    reportDWH,
    setRedirectUrl
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
